import { defineStore } from "pinia";
import { apiCall } from "../utils/api";

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    totalUser: 0, // 总用户数
    todayUser: 0, // 今日新增用户数
    totalDeposit: 0, // 总充值数
    todayDeposit: 0, // 今日新增充值数
    totalDraw: 0, // 总抽卡次数
    todayDraw: 0, // 今日新增抽卡次数
    totalCost: 0, // 总花费积分数
    todayCost: 0, // 今日花费积分数
  }),
  actions: {
    async getSummary() {
      const response = await apiCall("dashboard.getSummary", {});
      if (!response) {
        return false;
      }
      this.totalUser = response.totalUser;
      this.todayUser = response.todayUser;
      this.totalDeposit = response.totalDeposit;
      this.todayDeposit = response.todayDeposit;
      this.totalDraw = response.totalDraw;
      this.todayDraw = response.todayDraw;
      this.totalCost = response.totalCost;
      this.todayCost = response.todayCost;

      return true;
    },
  },
});
